import { getTheme } from './../utils';

export default {
  namespaced: true,
  state: {
    theme: null
  },
  getters: {
    getCurrentTheme: (state) => {
      return state.theme;
    }
  },
  mutations: {
    setTheme (state, theme) {
      state.theme = theme;
    }
  },
  actions: {
    getTheme: ({commit}, year) => {
      const theme = getTheme(year);
      commit('setTheme', theme)
    }
  }
};
